import { ButtonHTMLAttributes } from 'react';

import { Icons, IconsProps } from '../icons';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  iconProps: IconsProps;
};

export function IconButton(props: IconButtonProps) {
  const { children, iconProps, ...buttonProps } = props;

  return (
    <button {...buttonProps}>
      <Icons as='span' aria-hidden {...iconProps} />
      {children}
    </button>
  );
}
